import { usePostRequest } from '../../core/coreUseRequest';
import { useContext } from 'react';
import { store } from '../store';

/** useGenerateCharge ::  {} */
export default function useChangePassword() {
	const { dispatch } = useContext(store);
	return usePostRequest({
		dispatch,
		url: '/password/update/info'
	});
}
